// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"384de6ad","710":"efba4c22"}[chunkId] + ".chunk.js";
};